import React, { useEffect, useState, useRef } from "react";
import { FaEye } from "react-icons/fa";
import { getCurrentUser } from "../../../Api/auth.js";
import { RiCloseFill } from "react-icons/ri";
import Modal from "react-bootstrap/Modal";
import { MdClose } from "react-icons/md";
import { IoClose } from "react-icons/io5";

const TopTwo2 = () => {
    const [role_id, seRole_id] = useState(null);
    const playerRefs = useRef([]);
    const [ironDataModal, setIronDataModal] = useState(false);
    const [ironDataModal1, setIronDataModal1] = useState(false);
    const [ironDataModal2, setIronDataModal2] = useState(false);
    const handleCloseModal = () => {
        setIronDataModal(false);
    };
    const handleCloseModal1 = () => {
        setIronDataModal1(false);
    };
    const handleCloseModal2 = () => {
        setIronDataModal2(false);
    };

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        if (getCurrentUserdata && getCurrentUserdata.user) {
            seRole_id(getCurrentUserdata.user.role_id);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);

    return (
        <>
            <div className="step-new-new">
                <div className="step-content-item step-content-item-active step-1 ">
                    <div className="step remotefitting">
                        <div class="dashboard-sec mx-3">
                            {
                                role_id == 4 && (
                                    <div className="bg_color_sec">
                                        <div className="row align-items-center mb-3">
                                            <div className="">
                                                <div class="box-step-content admin-box">
                                                    <div class="box-title col-md-12">
                                                        <h4>Watch this to get started</h4>
                                                    </div>
                                                    <div class="box-text col-md-12">
                                                        <p>Before you start watch the videos below to get a grasp on what you will be doing and how the process works.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <div eventKey="0" className="mobile-accordion" onClick={() => setIronDataModal(true)}>
                                                        <div className="bg_green_light color_green_bg">
                                                            <div className="gs_fr_tops" id="lesson_card_1">
                                                                <div>
                                                                    <div className="gab_title">
                                                                        <div className="gab_text bg-accordion-title">
                                                                            <h5>What we will be doing here</h5>
                                                                        </div>
                                                                        <div className="">
                                                                            <div className="barplay_icon_item" >
                                                                                <FaEye size={15} color="#ffffff" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div eventKey="1" className="mobile-accordion" onClick={() => setIronDataModal1(true)}>
                                                        <div className="bg_green_light color_green_bg">
                                                            <div className="gs_fr_tops" id="lesson_card_1">
                                                                <div>
                                                                    <div className="gab_title">
                                                                        <div className="gab_text bg-accordion-title">
                                                                            <h5>Launch monitor data setup</h5>
                                                                        </div>
                                                                        <div className="">
                                                                            <div className="barplay_icon_item">
                                                                                <FaEye size={15} color="#ffffff" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div eventKey="2" className="mobile-accordion" onClick={() => setIronDataModal2(true)}>
                                                        <div className="bg_green_light color_green_bg">
                                                            <div className="gs_fr_tops" id="lesson_card_1">
                                                                <div>
                                                                    <div className="gab_title">
                                                                        <div className="gab_text bg-accordion-title">
                                                                            <h5>Who to contact for help</h5>
                                                                        </div>
                                                                        <div className="">
                                                                            <div className="barplay_icon_item">
                                                                                <FaEye size={15} color="#ffffff" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Modal  centered show={ironDataModal} className="step card-radius popup-modal-dark" >
    <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile" style={{ padding:'4px 15px' }}>
            <div className='row d-flex justify-content-between align-items-center' >
                <img className='col-9 text-white remote-text mt-4' src={require("../../../assets/images/remote-fitting-logo.png")} alt="logo" />
                <div className="col-3 closing-icon d-flex align-items-center justify-content-end">
                    {/* <IoClose
                        color="#ffffff"
                        onClick={handleCloseModal}
                    /> */}
                    <button type="button" className="btn-close" style={{ backgroundColor: 'transparent', border: 'none' }} onClick={handleCloseModal} aria-label="Close">
                        <IoClose style={{ strokeWidth: '30px' }}/>
                    </button>
                </div>
            </div>

        <div className="row">
            <div className='sec-header-dash border-header-sec mb-0'>
                <div className="box-title mb-0" style={{ color: 'ffffff' }}>
                    <h3 className="box-title-lable">
                        <span className="color">1</span>Filming your swing
                    </h3>
                </div>
                <div className="desc m-0">
                    <p className='ms-3'>
                        You will upload a down the line and face on angle of your golf swing into the first section of the remote fitting application.
                    </p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className='sec-header-dash border-header-sec mb-0'>
                <div className="box-title mb-0" style={{ color: 'ffffff' }}>
                    <h3 className="box-title-lable">
                        <span className="color">2</span>Testing the irons
                    </h3>
                </div>
                <div className="desc m-0">
                    <p className='ms-3'>
                        The second step is going through our 8 stage, color cordinated iron testing process. Spray your face, hit your shots and document.
                    </p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className='sec-header-dash border-header-sec mb-0'>
                <div className="box-title mb-0" style={{ color: 'ffffff' }}>
                    <h3 className="box-title-lable">
                        <span className="color">3</span>Attaching ball data
                    </h3>
                </div>
                <div className="desc m-0">
                    <p className='ms-3'>
                        Depending on what launch monitor you use, you will export your data and attach it to our interface in the form of a link or file.
                    </p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className='sec-header-dash border-header-sec mb-0'>
                <div className="box-title mb-0" style={{ color: 'ffffff' }}>
                    <h3 className="box-title-lable">
                        <span className="color">4</span>Finishing up
                    </h3>
                </div>
                <div className="desc m-0">
                    <p className='ms-3'>
                        Once you have submitted all your fitting info you have the option to leave us a note. Once you submit we will get you your prescription.
                    </p>
                </div>
            </div>
        </div>
    </Modal.Body>
</Modal >
            <Modal 
                show={ironDataModal1}
                centered
                className="step card-radius popup-modal-dark"
            >
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile" style={{ padding:'4px 15px' }}>
                <div className='row d-flex justify-content-between align-items-center' >
                                        <img className='col-9 text-white remote-text mt-4' src={require("../../../assets/images/remote-fitting-logo.png")} alt="logo" />
                                        <div className="col-3 closing-icon d-flex align-items-center justify-content-end">
                                            {/* <IoClose
                                                color="#ffffff"
                                                onClick={handleCloseModal}
                                            /> */}
                                            <button type="button" className="btn-close" style={{ backgroundColor: 'transparent', border: 'none' }} onClick={handleCloseModal1} aria-label="Close">
                                                <IoClose style={{ strokeWidth: '30px' }}/>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className='col-12 mb-0'>
                                            <div className="ifream-video-box ratio iframe_wrapper" style={{ paddingBottom: '177.78%' }}>
                                                <div id="player" className="v-video">
                                                    <iframe
                                                        ref={(el) => (playerRefs.current[0] = el)}
                                                        src="https://player.vimeo.com/video/1045505113?badge=0&autopause=0&player_id=0&app_id=58479&controls=1"
                                                        frameBorder="0"
                                                        allow="autoplay; fullscreen; picture-in-picture"
                                                        allowFullScreen
                                                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                        title="Your Video Title"
                                                        data-ready="true"
                                                    ></iframe>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={ironDataModal2}
                centered
                className="step card-radius popup-modal-dark"
            >
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile" style={{ padding:'4px 15px' }}>
                <div className='row d-flex justify-content-between align-items-center' >
    <img className='col-9 text-white remote-text mt-4' src={require("../../../assets/images/remote-fitting-logo.png")} alt="logo" />
    <div className="col-3 closing-icon d-flex align-items-center justify-content-end">
        {/* <IoClose
            color="#ffffff"
            onClick={handleCloseModal}
        /> */}
        <button type="button" className="btn-close" style={{ backgroundColor: 'transparent', border: 'none' }} onClick={handleCloseModal2} aria-label="Close">
            <IoClose style={{ strokeWidth: '30px' }}/>
        </button>
    </div>
</div>
<div className="row">
    <div className='col-12 mb-0'>
        <div className="ifream-video-box ratio iframe_wrapper" style={{ paddingBottom: '177.78%' }}>
            <div id="player" className="v-video">
                <iframe
                    ref={(el) => (playerRefs.current[0] = el)}
                    src="https://player.vimeo.com/video/1045510865?badge=0&autopause=0&player_id=0&app_id=58479&controls=1"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    title="Your Video Title"
                    data-ready="true"
                ></iframe>
            </div>
        </div>
    </div>
</div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default TopTwo2;
